import { ReactComponent as IconRightDownArrow } from '../../Icons/Sidebar/RightDownArrow.svg';
import React, { useState, useRef, useEffect } from 'react';
import { getCurrentUser } from 'utils/Global';
import { IStyle } from 'Styles';
import { useRMDispatch } from 'redux/hooks';
import { setSelectedGroup } from 'redux/reducers/commonReducer';

type UserMenuButtonProps = {
  Icon: any;
  title: string;
  userPannelButtonsList: any[];
  hideGroups: boolean;
  selectedGroupId: number;
  disabled?: boolean;
};

export default function UserMenuButton({
  Icon,
  title,
  userPannelButtonsList,
  hideGroups,
  selectedGroupId,
  disabled = false,
}: UserMenuButtonProps) {
  const [showPanel, setShowPanel] = useState(false);
  const ref = useRef<HTMLInputElement>();
  const trimedTitle = title ? (title as string).truncate(13, true, true) : '';
  const [userGroups, setUserGroups] = useState([]);
  const dispatch = useRMDispatch();

  useEffect(() => {
    const handleClickOutside = (event) => {
      const current = ref.current;
      if (current != null && current != undefined) {
        if (!current?.contains(event.target)) {
          setShowPanel(false);
        }
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
  }, [ref]);

  useEffect(() => {
    const user = getCurrentUser();
    const groups = user?.groups ?? [];
    setUserGroups(groups);
    dispatch(setSelectedGroup(groups[0]));
  }, []);

  const onGroupChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const group = userGroups.find((g) => g.id === parseInt(e.target.value));
    dispatch(setSelectedGroup(group));
  };

  return (
    <div
      id="usermenubutton-container"
      ref={ref}
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <div
        id="usermenubutton-sidebar-item"
        className={`sidebar-item ${
          disabled ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''
        }`}
        style={{ width: '100%', height: '100%' }}
        title={title as string}
        onClick={() => {
          if (disabled) {
            return;
          }
          setShowPanel(!showPanel);
        }}
        aria-disabled={disabled}
      >
        <div id="usermenubutton-item-icon" className="sidebar-item-icon">
          {Icon}
        </div>

        <div
          id="usermenubutton-item-text"
          className="sidebar-item-text"
          style={styles.userTitle}
        >
          {trimedTitle}
        </div>
        <div id="usermenubutton-button-arrow" className="user-menu-button-arrow">
          <IconRightDownArrow />
        </div>
      </div>

      {showPanel ? (
        <div id="usermenubutton-user-dropdown-panel" className={'user-dropdown-panel'}>
          <div
            id="usermenubutton-user-text-panel"
            className="user-panel-text"
            style={{ height: '17.84%', width: '100%' }}
          >
            Hi, {title}
          </div>
          <div
            id="usermenubutton-user-border-panel-wrapper"
            className="user-panel-border-line"
          />
          {hideGroups ? null : (
            <div
              id="usermenubutton-user-panel-item-dropdown-container"
              className="user-panel-item-dropdown-container"
            >
              <div
                id="usermenubutton-user-panel-item-dropdown-heading"
                className="user-panel-item-dropdown-heading"
              >
                Groups
              </div>
              <select
                id="usermenubutton-user-panel-item-dropdown-select"
                onChange={onGroupChange}
                style={{ width: '100%', height: '32px', marginTop: '6px' }}
              >
                {userGroups.map((_group, index) => (
                  <option
                    id="usermenubutton-user-panel-item-dropdown-option"
                    selected={_group.id == selectedGroupId}
                    key={index}
                    value={_group.id}
                  >
                    {_group.name}
                  </option>
                ))}
              </select>
            </div>
          )}
          {userPannelButtonsList.map((item, index) => (
            <div
              id="usermenubutton-user-pannel-buttons-list"
              key={index}
              className={
                item.onClick == null
                  ? 'user-pannel-item-disabled'
                  : 'user-pannel-item enabledDiv'
              }
              onClick={item.onClick}
            >
              <div
                id="usermenubutton-user-panel-item-icon-container"
                className="user-panel-item-icon-container"
              >
                {item.icon}
              </div>
              <div
                id="usermenubutton-user-panel-item-text-container"
                className="user-panel-item-text-container"
              >
                {item.text}
              </div>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}

const styles: IStyle = {
  userTitle: {
    textAlign: 'left',
  },
};
